import './OrdermadeBanner.svelte.css';
/* src/components/ordermadeBanner/OrdermadeBanner.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	src_url_equal
} from "../../../_snowpack/pkg/svelte/internal.js";

function create_else_block(ctx) {
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*title*/ ctx[2] + "を簡単オーダーメイド作成できます。"));
			attr(img, "width", "740");
			attr(img, "height", "133");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-yk7hjd");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "title", a_title_value = "" + (/*title*/ ctx[2] + "を作成する"));
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 4 && img_alt_value !== (img_alt_value = "" + (/*title*/ ctx[2] + "を簡単オーダーメイド作成できます。"))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (dirty & /*title*/ 4 && a_title_value !== (a_title_value = "" + (/*title*/ ctx[2] + "を作成する"))) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (39:40) 
function create_if_block_3(ctx) {
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*title*/ ctx[2] + "のアクセサリーを簡単オーダーメイド作成できます。"));
			attr(img, "width", "740");
			attr(img, "height", "133");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-yk7hjd");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "title", a_title_value = "" + (/*title*/ ctx[2] + "のアクセサリーを作成"));
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 4 && img_alt_value !== (img_alt_value = "" + (/*title*/ ctx[2] + "のアクセサリーを簡単オーダーメイド作成できます。"))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (dirty & /*title*/ 4 && a_title_value !== (a_title_value = "" + (/*title*/ ctx[2] + "のアクセサリーを作成"))) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (29:36) 
function create_if_block_2(ctx) {
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*title*/ ctx[2] + "のアクセサリーを簡単オーダーメイド作成できます。"));
			attr(img, "width", "740");
			attr(img, "height", "133");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-yk7hjd");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "title", a_title_value = "" + (/*title*/ ctx[2] + "のアクセサリーを作成"));
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 4 && img_alt_value !== (img_alt_value = "" + (/*title*/ ctx[2] + "のアクセサリーを簡単オーダーメイド作成できます。"))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (dirty & /*title*/ 4 && a_title_value !== (a_title_value = "" + (/*title*/ ctx[2] + "のアクセサリーを作成"))) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (19:34) 
function create_if_block_1(ctx) {
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*title*/ ctx[2] + "を簡単オーダーメイド作成できます。"));
			attr(img, "width", "740");
			attr(img, "height", "133");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-yk7hjd");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "title", a_title_value = "" + (/*title*/ ctx[2] + "を作成する"));
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 4 && img_alt_value !== (img_alt_value = "" + (/*title*/ ctx[2] + "を簡単オーダーメイド作成できます。"))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (dirty & /*title*/ 4 && a_title_value !== (a_title_value = "" + (/*title*/ ctx[2] + "を作成する"))) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (9:1) {#if 'jewellery' === pagetype}
function create_if_block(ctx) {
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "パワーストーン" + /*title*/ ctx[2] + "を簡単オーダーメイド作成できます。");
			attr(img, "width", "740");
			attr(img, "height", "133");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-yk7hjd");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "title", a_title_value = "オーダーメイド" + /*title*/ ctx[2] + "作成");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[1])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 4 && img_alt_value !== (img_alt_value = "パワーストーン" + /*title*/ ctx[2] + "を簡単オーダーメイド作成できます。")) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (dirty & /*title*/ 4 && a_title_value !== (a_title_value = "オーダーメイド" + /*title*/ ctx[2] + "作成")) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

function create_fragment(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if ('jewellery' === /*pagetype*/ ctx[3]) return create_if_block;
		if ('fortune' === /*pagetype*/ ctx[3]) return create_if_block_1;
		if ('labelItem' === /*pagetype*/ ctx[3]) return create_if_block_2;
		if ('jewelleryCode' === /*pagetype*/ ctx[3]) return create_if_block_3;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "ordermade-banner svelte-yk7hjd");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { href } = $$props;
	let { src } = $$props;
	let { title } = $$props;
	let { pagetype } = $$props;

	$$self.$$set = $$props => {
		if ('href' in $$props) $$invalidate(0, href = $$props.href);
		if ('src' in $$props) $$invalidate(1, src = $$props.src);
		if ('title' in $$props) $$invalidate(2, title = $$props.title);
		if ('pagetype' in $$props) $$invalidate(3, pagetype = $$props.pagetype);
	};

	return [href, src, title, pagetype];
}

class OrdermadeBanner extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { href: 0, src: 1, title: 2, pagetype: 3 });
	}
}

export default OrdermadeBanner;